import React from 'react';
import './../App.css';
import BlueTicket from '../Components/BlueTicket';
import Search from '../Components/Search';
import Article from '../Components/Article';
import Editor from '../Components/Editor';
import SideBar from '../Components/SideBar';
import methodsOneContext from '../Contexts/MethodsOne';
import GoodsContainer from '../Components/GoodsContainer'
import PartialSite1 from '../Components/PartialSite1'


export default class App extends React.Component {
  constructor(props) {
    super(props);
    console.log(this.props.history.location.pathname);
  }
  
  state = {
    detailList : [],
    editId : -1
   }

   componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

   setDetailList(data){

      this.setState(prevState => {
        return {
          detailList : data,
          editId : -1
        }
      })

   }

   editDetail(id){
    this.setState(prevState => {
      return {
        editId : id
      }
    })
  }

    newEvent(){
      this.setState(prevState => {
        return { 
          detailList : [{Id:0 ,Description:'', Tag:''}],
          editId : 0
        }
      })

    console.log('رسsadadsadیدم');
    console.log(this.state);
    console.log(this.state.detailList);

   }

  render() {
    let detailList = this.state.detailList;
    let editId = this.state.editId;
    return (

      <>
                <div class="header_section">
                    <PartialSite1 />
                </div>
                <GoodsContainer />

      </>
    )
  }
}


